import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-assignment-submit-dialog-box',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './assignment-submit-dialog-box.component.html',
	styleUrl: './assignment-submit-dialog-box.component.scss'
})
export class AssignmentSubmitDialogBoxComponent {


	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<AssignmentSubmitDialogBoxComponent>
	) { }

	sendInvitation() {
		this.dialogRef.close(true);
	}

	close() {
		this.dialogRef.close();
	}


	getDuration(timeLimit: number | null | undefined): string {
		if (!timeLimit) {
			return '—';
		}
		const minutes = timeLimit / 60;
		if (minutes >= 60) {
			const hours = Math.floor(minutes / 60);
			const remainingMinutes = minutes % 60;
			return remainingMinutes
				? `${hours} hr ${remainingMinutes} min`
				: `${hours} hr`;
		}
		return `${minutes} min`;
	}

}
